import { render } from "./CreateEditTemplateOrder.vue?vue&type=template&id=ef6ce708&scoped=true"
import script from "./CreateEditTemplateOrder.vue?vue&type=script&lang=js"
export * from "./CreateEditTemplateOrder.vue?vue&type=script&lang=js"

import "./CreateEditTemplateOrder.vue?vue&type=style&index=0&id=ef6ce708&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef6ce708"]])

export default __exports__